import { Dialog } from '@components/ui/dialog'
import type { DialogProps } from '@radix-ui/react-dialog'

export default function ModalRoot(props: DialogProps): JSX.Element {
  return <Dialog {...props} />
}
